import React, { useContext } from 'react';
import classnames from 'classnames';
import { CommentContext } from '../CommentContext';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import SpamCommentBody from '../SpamCommentBody';
import { BiDataHook } from '../../../biLogger/constants';
import HiddenCommentBody from '../HiddenCommentBody';
import CommentBadges from '../CommentBadges';
import s from './CommentBody.scss';
var CommentBody = function (_a) {
    var header = _a.header, footer = _a.footer, className = _a.className, bodyClassName = _a.bodyClassName, onMouseLeave = _a.onMouseLeave;
    var _b = useContext(CommentContext), comment = _b.comment, _c = _b.comment, isSpam = _c.isSpam, isHidden = _c.isHidden, textContent = _c.textContent, commentId = _c.commentId, isPeeking = _b.isPeeking;
    var isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden;
    var isVisible = !isAdminHidden && !isDeleted;
    if (!isPeeking && isSpam && comment.replies !== 0) {
        return React.createElement(SpamCommentBody, null);
    }
    if (!isPeeking && (isHidden || !isVisible) && comment.replies !== 0) {
        return React.createElement(HiddenCommentBody, { className: className });
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return null;
    }
    return (React.createElement("div", { className: className, onMouseLeave: onMouseLeave },
        header,
        !!textContent && (React.createElement("div", { className: s['comment-body-wrap'], "data-hook": BiDataHook.COMMENT_BODY },
            React.createElement(TextRenderer, { textContent: textContent, reactViewer: CommentViewer, className: classnames(s['comment'], bodyClassName), legacyTheme: 'comments', viewerKey: commentId }))),
        comment.awardedBadges && React.createElement(CommentBadges, null),
        footer));
};
CommentBody.displayName = 'CommentBody';
export default CommentBody;
//# sourceMappingURL=CommentBody.js.map